var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDualballback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "rgb(241, 240, 240)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 20,
    fill: "#4484ff",
    cy: 50,
    cx: 30
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.5s",
    values: "30;70;30",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 20,
    fill: "#ffad3d",
    cy: 50,
    cx: 70
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    values: "30;70;30",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 20,
    fill: "#4484ff",
    cy: 50,
    cx: 30
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.5s",
    values: "30;70;30",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "cx"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.499;0.5;1",
    calcMode: "discrete",
    values: "0;0;1;1",
    attributeName: "fill-opacity"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDualballback);
export default __webpack_public_path__ + "static/media/dual ball back.c11b952d518cd141417f729dd8b49454.svg";
export { ForwardRef as ReactComponent };